import { useRef } from 'react';
import isShallowEqual from 'utils/isShallowEqual';

/**
 * This memoizes a single object.  If the object you pass in shallow-equals
 * the object you last passed in, then this will return the old object instead of
 * the new object.
 */
export function useMemoShallowEquals<T>(obj: T): T {
  const ref = useRef<T | undefined>();

  if (ref === undefined || !isShallowEqual(ref.current, obj)) {
    ref.current = obj;
  }

  return ref.current as T;
}
